/*
 * @Date: 2025-03-31 02:32:53
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-11-06 14:37:55
 */
import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { AppProviders } from "./context/AppProviders";
import ScrollToTop from "./components/ScrollToTop";

const DefinedRouters = React.lazy(() => import("./router"));

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: auto;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y; 
    scroll-behavior: smooth;
  }
    
  body {
    margin: 0;
    padding: 0;
    color: #000;
    font-size: 24rem;
    line-height: 32rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
    html {
  overflow: hidden;
}
body {
  overflow-y: scroll;
}
   meta[name="format-detection"] {
    telephone=no;
    email=no;
    address=no;
  }

  a[href^="tel"],
  a[href^="mailto"],
  a[href^="address"] {
    text-decoration: none !important;
    color: inherit !important;
    border-bottom: none !important;
  }

  a.custom-link,
  a.project-link {
    text-decoration: underline;
    border-bottom: 1px solid currentColor;
  }
`;

function App() {
  return (
    <AppProviders>
      <Router>
        <GlobalStyle />
        {/* <Suspense fallback={<LoadingContainer>Loading...</LoadingContainer>}> */}
        <Suspense>
          <DefinedRouters />
        </Suspense>
      </Router>
    </AppProviders>
  );
}

export default App;
